<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-03 14:50:12
 * @Description: 官网首页
 -->

<template>
  <div class="index-wrapper">
    <swiper-wrapper></swiper-wrapper>
    <banner></banner>
    <jinr-important></jinr-important>
    <mid-tab></mid-tab>
    <news></news>
    <partner></partner>
    <!-- <index-footer></index-footer> -->
  </div>
</template>
<script>
import SwiperWrapper from './components/swiper';
import Banner from './components/banner';
import JinrImportant from './components/jinr-important';
import MidTab from './components/mid-tab';
import News from './components/news';
import Partner from './components/partner';
// import IndexFooter from './components/footer';
export default {
  components: {
    SwiperWrapper,
    Banner,
    JinrImportant,
    MidTab,
    News,
    Partner
    // IndexFooter
  }
};
</script>
<style lang="less" scope></style>
